module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-rash.164db6fb.svg";